module.exports = __webpack_public_path__ + "img/warning_sign_icon.ea0b5698.svg";